<template>
  <div class="car-details" v-loading="oLoading.detail && this.id">
    <QS-h3-title>
      <template slot="title">出入库记录详情</template>
      <template slot="right">
        <!-- $route.query.tabType 判断是否在车辆详情中 $route.query.tabType有值的话代表在否则不在 -->
        <!-- isShowEdit -->
        <el-button v-if="isShowEdit&&!$route.query.tabType" @click="editHandle"
          type="primary" size="small" class="float-right">编辑</el-button>
        <el-button  v-if="$route.query.tabType" slot="right" @click="()=>{$router.back()}">返回</el-button>
      </template>
      <div class="splitline" />
    </QS-h3-title>
    <div>
      <section class="item">
          <QS-h4-title title="车辆信息" />
          <column-box
              :source="carInfoVo"
              :list="carInfoList"
              :labelWidth="130"
          ></column-box>
      </section>
      <section class="item">
        <QS-h4-title title="交接信息" />
        <column-box :source="stockInfoVo" :list="stockKeyList" :labelWidth="130"></column-box>
      </section>
      <section>
        <QS-h4-title title="验车信息" />
        <div class="carPhoto-box">
          <div class="carPhoto-title">验车交接文件</div>
          <div class="photo-box" v-if="stockInfoVo.inspectionAttachment">
            <div v-for="(item, index) in stockInfoVo.inspectionAttachment" :key="'inspectionAttachment' + index" class="photo-item">
              <template v-if="item.url">
                <div class="imgPhoto">
                  <EnlargeImg :imgSrc="item.url"/>
                </div>
                <div class="imgPhoto-title">说明：{{ item.remark || '--'}}</div>
              </template>
              <template v-else-if="item.urlList">
                <div style="display:flex">
                <div class="imgPhoto" v-for="(urlItem, index) in item.urlList" :key="index">
                  <EnlargeImg :imgSrc="urlItem.url"/>
                </div>
              </div>
              <div class="imgPhoto-title">说明：{{ item.remark || '--'}}</div>
              </template>
              <template v-else>
                <span>--</span>
              </template>
            </div>
          </div>
        </div>

        <div class="carPhoto-box">
          <div class="carPhoto-title">车辆相关照片</div>
          <div class="photo-box" v-if="stockInfoVo.photo">
            <div v-for="(item, index) in stockInfoVo.photo" :key="'photo' + index" class="photo-item">
              <div style="display:flex">
                <div class="imgPhoto" v-for="(urlItem, index) in item.urlList" :key="index">
                  <EnlargeImg :imgSrc="urlItem.url" />
                </div>
              </div>
              <div class="imgPhoto-title" v-if="item.remark">说明：{{ item.remark }}</div>
              <div class="imgPhoto-title" v-else>说明：--</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SelectOption from '@/store/dict/selectOptionDict'
import CARDICT from '@/store/dict/carDict.js'
import { getOutInDetailsSensitive } from '@/api/domain/cars'

export default {
  data() {
    return {
      oLoading: {
        detail: false,
      },
      id: '',
      carId: '',
      stockId: '',
      stockInfoVo: {},
      carInfoVo: {},
      rentOrderVO: {},
      stockKeyList: [
        { key: 'actualTakeOverName', name: '提车人姓名' },
        { key: 'actualTakeOverTel', name: '提车人联系电话' },
        { key: 'managerName', name: '交接车管' },
        { key: 'displayMile', name: '表显里程' },
        { key: 'remainingReserves', name: '剩余电量/油量' },
        { key: 'takeOverTime', name: '验车完成时间' },
        { key: 'remarks', name: '备注', clone: true },
      ],
      payDataList: [],
      payDataListSlice: [],
      type: '',
      carInfoList: [
        { key: 'plateNo', name: '车牌号' },
        { key: 'brandName', name: '品牌' },
        { key: 'seriesName', name: '车系' },
        { key: 'name', name: '车型' },
        { key: 'customerName', name: '提车人姓名' },
        { key: 'contactTel', name: '提车人手机号' },
        { key: 'vin', name: '车架号（VIN码）' },
      ],
    }
  },
  computed: {
    // 出入库状态 0待处理/1已完成/2已作废
    outInState() {
      if (this.stockInfoVo) {
        if (this.stockInfoVo.state || this.stockInfoVo.state === 0) {
          return this.stockInfoVo.state
        } else {
          return 2 // 默认是作废不显示编辑按钮
        }
      } else {
        return 2 // 默认是作废不显示编辑按钮
      }
    },
    // 编辑按钮是否显示
    isShowEdit() {
      const { tab } = this.$route.query
      return this.judgePermission('carOperationOutInEdit') && this.outInState !== 2 && !tab
    },
  },
  created() {
    const { id } = this.$route.query
    if (id) {
      this.id = parseInt(id)
      this.getOutInDetails()
    } else {
      this.$message.error('缺少ID参数')
    }
  },
  methods: {
    async getOutInDetails() {
      this.oLoading.detail = true
      const { code, data } = await getOutInDetailsSensitive({
        id: this.id,
      })

      if (code === 1) {
        this.carId = data.carInfoVo.carId
        this.stockId = data.stockInfoVo.stockId
        this.stockInfoVo = { ...data.stockInfoVo }
        // 车辆相关照片
        this.stockInfoVo.photo = this.imageFilter(data?.stockInfoVo?.photo)
        // 验车交接文件
        this.stockInfoVo.inspectionAttachment = this.imageFilter(data?.stockInfoVo?.inspectionAttachment)

        this.stockInfoVo.displayMile = this.stockInfoVo.displayMile ? `${this.stockInfoVo.displayMile} 公里` : ''
        this.type = this.stockInfoVo.type
        this.stockInfoVo.type = CARDICT.OUT_INT_TYPE()[this.stockInfoVo.type]
        this.carInfoVo = { ...data.carInfoVo,
          contactTel: data.rentOrderVO.contactTel,
          customerName: data.rentOrderVO.customerName,
          startDate: `${data.rentOrderVO.effectDate}至${data.rentOrderVO.endDate}`,
          rentCategoryName: data.rentOrderVO.rentCategoryName,
        }
        // 订单信息
        if (data.rentOrderVO) {
          // 订单状态
          this.rentOrderVO = { ...data.rentOrderVO }
          this.rentOrderVO.state =
            SelectOption.leaseOrderState[this.rentOrderVO.state]
        }
        this.payDataList = data.collectionInfoVo
        this.payDataListSlice = data.collectionInfoVo
      } else {
        this.$message.error('获取详情失败')
      }
      this.oLoading.detail = false
    },
    // 跳转编辑页面
    editHandle() {
      this.$router.push({
        path: '/carManage/operationOutIn/edit',
        query: {
          stockId: this.stockId,
          orderId: this.$route.query.orderId,
        },
      })
    },
    // 图片处理
    imageFilter(data) {
      if (!data) return []
      let result
      try {
        result = JSON.parse(data)
      } catch (error) {
        result = data
      }

      Array.isArray(result) && result.forEach((item) => {
        item.urlList = this.getEchoUploadFileData(item?.urlList, true)
      })
      return result || []
    },
  },
}
</script>

<style scoped lang="scss">
.imgPhoto {
  width: 80px;
  height: 80px;
  margin: 0 10px 5px 0;
}

.img-item {
  display: flex;
  margin-bottom: 10px;

  // min-height: 105px;
  .label {
    padding-right: 12px;
    width: 130px;
    text-align: right;
    box-sizing: border-box;
  }

  .content {
    max-width: 480px;
    display: flex;
    flex-wrap: wrap;

    .item {
      margin-left: 16px;
      width: 80px;

      &:nth-child(5n + 1) {
        margin-left: 0;
      }

      &:nth-child(n + 6) {
        margin-top: 6px;
      }
    }

    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #969799;
      line-height: 25px;
      overflow: hidden;
      text-align: center;
    }
  }
}

.lh28 {
  line-height: 28px;
}

.car-details {
  height: 100%;

  .float-right {
    float: right;
  }

  .details-container {
    position: relative;
    height: calc(100% - 80px);
  }

  .file-list {
    padding-left: 0;
    list-style: none;

    li {
      display: flex;

      [class^='el-icon'] {
        width: 20px;
        line-height: 28px;
        color: #2e7eff;
        padding-right: 10px;
      }

      p {
        flex: 1;
        color: #2e7eff;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}

.carPhoto-box {
  display: flex;
  margin: 10px 0 0 50px;

  // align-items: center;
  .carPhoto-title {
    width: 110px;
    color: #333;
  }
}

.photo-box {

  // display: flex;
  // flex-wrap: wrap;
  .photo-item {
    margin-bottom: 10px;
  }

  .imgPhoto-title {
    width: 40vw;
    word-break: break-all;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
}
</style>
